const translations = {
  email: 'Email',
  password: 'Password',
  submit: 'Login',
  welcome: 'Welcome to Btime!',
  ssoLogin: 'SSO Login',
  ssoLoginRedirectMessage: 'You will be redirected to the home screen shortly.',
  loginWithGoogle: 'Sign in with Google',
  'createPasswordModal.title': 'To continue, create a new password!',
  'createPasswordModal.subtitle': 'Check the tips for creating a secure password!',
  'createPasswordModal.useFieldsBelow': 'Use the fields below',
  'createPasswordModal.newPassword': 'New Password',
  'createPasswordModal.repeatPassword': 'Repeat Password',
  'createPasswordModal.createAndContinue': 'Create and continue!',
  'createPasswordModal.checkFieldsBelow': 'Check the fields below!',
  'createPasswordModal.tryAgain': 'Try again',
  'passwordValidations.min8Characters': 'Type at least 8 characters',
  'passwordValidations.minOneLetter': 'Use at least one letter',
  'passwordValidations.minOneNumber': 'Use at least one number',
  'passwordValidations.passwordsMustMatch': 'The entered passwords must match',
  'passwordValidations.recommendationUppercase': 'Recommendation: Use an uppercase letter',
  'passwordValidations.recommendationSpecialChars': 'Recommendation: Use special characters, e.g.: @$%&!',
  'newPasswordForm.resettingPassword': 'Resetting password!',
  'newPasswordForm.confirmPassword': 'Confirm password',
  'newPasswordForm.passwordsDoNotMatch': 'The entered passwords do not match!',
  'newPasswordForm.enterPasswordAndConfirmation': 'Enter the password and confirmation to continue!',
  'newPasswordForm.changePassword': 'Change password',
  'newPasswordForm.passwordSetSuccess': 'Password set successfully',
  'newPasswordForm.passwordSetDescription':
    'If the request was made from a mobile device, open the app and log in with the new password.',
  'newPasswordForm.linkNoLongerValid': 'It seems this link is no longer valid',
  'newPasswordForm.requestNewPasswordChange': 'Try requesting a new password change',
  'newPasswordForm.passwordNotUpdated': 'Password not updated',
  'forgotPasswordForm.forgotPassword': 'Forgot password?',
  'forgotPasswordForm.requestNewPassword': 'Request new password',
  'forgotPasswordForm.requestCompleted': 'Request completed',
  'forgotPasswordForm.emailBeingSent': 'An email is being sent to you to reset your password.',
  'forgotPasswordForm.tryAgain': 'Try again',
  'authFromAdmin.title': 'Login from Admin',
  'authFromAdmin.subtitle':
    'You will be redirected to the home screen shortly. If this does not happen, go through the process again from the Admin.',
  'loginTemplate.platformTitle': 'Operational Management Platform',
  'loginTemplate.platformDescription':
    'Btime is a SaaS operational management platform that automates workflows, standardizes processes and increases the productivity and efficiency of internal or external teams',
  'viewSwitcher.wantToLogin': 'Want to login?',
  'viewSwitcher.clickHere': 'Click here'
}

export default translations
